import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import AccountSubscription from "./SectionSub/BillingInfo/AccountSubscription";
import { useTranslation } from '../../language';



export default function SubscriptionWelcome() {

 const { t } = useTranslation();
        
 
return (

<PageProtectedLayout
    
    headline={t('page_hl_account')}
    specify={t('page_sp_your_subscription')} 

     >
 
 {/* Main Page Content */}
      <AccountSubscription />

</PageProtectedLayout>

)}